export default "__VITE_ASSET__2342d175__"